module.exports = __webpack_public_path__ + "img/dashboard.274abf3a.svg";